import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { singleCompletedAuctionDetails } from "../../../../redux/action/singleAuction";
import { getSingleCompletedOfferForSeller } from "../../../../redux/action/singleBrand";
// import AuctionBidTable from "../../dashboard/singleOffer/table/AuctionBidTable";
import AuctionSchedule from "../../dashboard/comman/AuctionSchedule";
import EmdPaidTables from "../../dashboard/singleOffer/table/EmdPaidTables";
import LotPriceApprovalTable from "../table/LotPriceApprovalTable";
import ProductScrapDetail from "../../dashboard/singleOffer/components/ProductScrapDetail";

function ProductOfferBidDetail() {
  const { id, offerId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { singleAuctionData, loading } = useSelector(
    (state) => state.singleAuction
  );
  const { singleOfferData, loadings } = useSelector(
    (state) => state.singleBrand
  );

  useEffect(() => {
    dispatch(singleCompletedAuctionDetails(id));
    dispatch(getSingleCompletedOfferForSeller(id, offerId));
  }, [dispatch, id, offerId]);

  return (
    <div>
      <span className="valign-wrapper" style={{ gap: "25px" }}>
        <span
          className="material-icons-outlined pointer"
          onClick={() => navigate(-1)}
        >
          arrow_back
        </span>
        <h4>Lot Bid Details</h4>
      </span>

      <AuctionSchedule
        singleAuctionData={singleAuctionData}
        loading={loading}
      />
      <div className="full-width mt-2">
        <ProductScrapDetail loadings={loadings} singleOfferData={singleOfferData} />
        <h3 className="font-cercular-bold cercle-purple-text">
          Completed Lot Bids
        </h3>
        <LotPriceApprovalTable singleOfferData={singleOfferData} loadings={loadings} />
        {/* <AuctionBidTable pickupButton={true} /> */}
        <div className="mt-2">
          <h4 className="font-cercular-bold cercle-purple-text">
            EMD Paid Members
          </h4>
          <EmdPaidTables
            paidEmdDetails={singleOfferData?.depositedBy}
            loading={loadings}
          />
        </div>
      </div>
      {/* <div ref={contentRef} className="pdf-content">
        <DownloadAuctionBid />
      </div> */}
    </div>
  );
}

export default ProductOfferBidDetail;
